module.exports = __webpack_public_path__ + "img/1.931ee359.png";